
<div class="edit-page-root-container custom-menu-item-root-container">
    <div class="page-content">
        <!-- Page Header -->
        <div class="page-header">
            <div class="page-title">
                <img class="icon" src="assets/images/menu/svg/custom-menu.svg" width="30" height="30">
                <span class="title">Custom Menu Item</span>
            </div>

            <!-- Navigation Buttons -->
            <div class="action-btn-container">
                <button mat-flat-button class="action-btn btn-save" [disabled]="isSaving || !canEdit"
                    (click)="saveChanges()">
                    {{ isSaving ? 'SAVING...' : 'SAVE' }}
                </button>
                <button mat-flat-button class="action-btn btn-discard" [disabled]="isSaving" (click)="resetToDefault()">
                    DISCARD
                </button>
            </div>
        </div>

        <!-- Page Details -->
        <div class="page-details">
            <div class="detail-section general-settings">
                <div class="content-container">
                    <!-- Menu Shortcuts Table -->
                    <div class="table-container">
                        <table class="menu-table" *ngIf="menuCategories.length > 0">
                            <!-- Table Header -->
                            <thead>
                                <tr>
                                    <th class="si-column">SI</th>
                                    <th class="function-column">Functions</th>
                                    <th class="role-column" *ngFor="let role of roles">
                                        <div class="col-title">
                                            <span>{{ role.label }}</span>
                                            <mat-checkbox [checked]="isAllSelected(role.key)"
                                                [indeterminate]="isIndeterminate(role.key)"
                                                (change)="toggleAllForRole(role.key, $event.checked)"
                                                [disabled]="!canEdit || isSaving">

                                            </mat-checkbox>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            
                            <!-- Table Body -->
                            <tbody>
                                <!-- Category and Items -->
                                <ng-container *ngFor="let category of menuCategories; let catIndex = index; trackBy: trackByKey">
                                    <!-- Category Header Row -->
                                    <tr class="category-row">
                                        <td colspan="7" class="category-title">{{ category.title }}</td>
                                    </tr>
                                    
                                    <!-- Menu Items -->
                                    <tr class="menu-item-row" 
                                        *ngFor="let item of category.items; let itemIndex = index; trackBy: trackByKey">
                                        <td class="si-cell">{{ getDisplayNumber(catIndex, itemIndex) }}</td>
                                        <td class="function-cell" [title]="item.function">{{ item.function }}</td>
                                        <td class="role-cell" *ngFor="let role of roles">
                                            <mat-checkbox 
                                                [checked]="isChecked(item.id, role.key)"
                                                (change)="onPermissionChange(item.id, role.key, $event.checked)"
                                                [disabled]="!canEdit || isSaving">
                                            </mat-checkbox>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>

                        <!-- Loading Message -->
                        <div *ngIf="menuCategories.length === 0" class="no-data">
                            <p>Loading menu shortcuts...</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
